// Message for future Jacob
// As of 17 July 2023, Javascript date doesn't have a built-in function to format dates using the datetime format (e.g. yyyy-mm-ddThh:mm:ss.000Z)
// https://stackoverflow.com/questions/3066586/get-string-in-yyyymmdd-format-from-js-date-object
// Either use a library (Moment.js), or concatenate them manually via date's methods (like toLocateDateString or getDay).


// Formats date for blog posts
const getDateAndTime = (date) => {
  const tempDate = new Date(date)

  const formattedDate = tempDate.toLocaleDateString(undefined, { month: "short", day: "numeric"})
  
  const yearNow = new Date().getFullYear()
  const yearThen = tempDate.getFullYear();
  const formattedYear = yearNow === yearThen ? "" : yearThen 

  const formattedTime = tempDate.toLocaleTimeString(undefined, { hour: "numeric", minute: "numeric"})

  return [formattedTime, formattedDate + " " + formattedYear]
}

export default getDateAndTime